import React from 'react';
import { Switch, useHistory } from 'react-router';
import { BaseRoute } from 'src/routing/BaseRoute';
import { IRoute } from '../../../routing/AppRoutes';

import { UserPageTitle } from 'src/features/user/common/UserPageTitle';
import { UserPageCard } from 'src/features/user/common/UserPageCard';

import { isEditingEventsForm } from 'src/utils/helpers';
import { makeStyles } from '@material-ui/core';
import BBLogo from './BB Logo.png';

type PEventsContacts = {
  routes: Array<IRoute>;
};


const useStyles = makeStyles((theme) => ({
  customHead: {
    '& .custom': {
      alignItems: 'center',
    },
    '& .m-b-0': {
      marginBottom: '0 !important'
    }
  },
}))


export const CreateEventsLayout: React.FC<PEventsContacts> = (props) => {
  const { routes } = props;
  const history = useHistory(); 
  const classes = useStyles();
  const isEditForm = isEditingEventsForm(history.location.pathname);
  const dynamicTitle = isEditForm ? 'Edit' : 'Logo';

  return (
    <UserPageCard>
      <div className={classes.customHead}>
		  <div>
			<img src={BBLogo} width="300" height="auto" alt="Background briefing" />
		  </div>
		  <UserPageTitle
          description="Schedule a media roundtable"
          />
      </div>
      <Switch>
        {routes.map((route) => (
          <BaseRoute {...route} key={route.path} />
        ))}
      </Switch>
    </UserPageCard>
  );
};
